<template lang="html">
  <button
    class="shop-button lundi"
    type="button"
    name="button"
    @click="addToCart"
  >
    <template v-if="preorder"
      >Pre-order</template
    >
    <template v-else
      >Ajouter au panier</template
    >
  </button>
</template>

<script>
export default {
  props: {
    product: Object,
    sku: Object,
    preorder: String
  },
  methods: {
    addToCart() {
      if (!this.sku) {
        this.$root.$emit("sizeMissing");
      } else {
        this.$store.commit("shop/addToCart", {
          id: this.sku.id,
          product_id: this.product.uid,
          title: this.product.title,
          quantity: 1,
          size: this.sku.taille,
          price: this.sku.price,
          shipping_weight: this.sku.weight,
          shipping_width: this.sku.width,
          shipping_height: this.sku.height,
          shipping_length: this.sku.length
        });
        this.$root.$emit("toggleCart");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.shop-button {
  -webkit-appearance: none;
  border: 0;
  outline: none;
  font-size: var(--fs);
  line-height: var(--lh);
  background: black;
  color: white;
  padding: var(--pad);
  transition: background 0.5s;
  border-right: 1px solid black;
  cursor: pointer;
  &:hover {
    background: var(--orange);
  }
}
</style>
